import {Component, HostBinding} from '@angular/core';

@Component({
  selector: 'app-donation-kakaopay',
  template: `
    <iframe style="border:0; width:100%; height:600px;" src="https://link.kakaopay.com/_/jjJZvgi">
    </iframe>
  `,
})
export class DonationKakaopayComponent {
  @HostBinding('class') class = "iframe-container";
}
